import { logError } from "@/lib/logError";
import { Product } from "@generated/types";

import { StatementPDFData } from "./statementTypes";

export async function generateStatementPDF(
  data: StatementPDFData,
  filename: string,
  logoUrl?: string,
  products: Product[] = []
): Promise<void> {
  try {
    // Loaded on demand, never statically: see no-restricted-imports in eslint.config.mjs.
    const { pdf } = await import("@react-pdf/renderer");

    // Generate the PDF blob based on account type
    let blob: Blob;

    if (data.accountType === "currencies") {
      const { FiatStatementPDF } = await import("./fiatStatementPdfTemplate");

      blob = await pdf(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        FiatStatementPDF({ data, logoUrl, products }) as any
      ).toBlob();
    } else {
      const { BlockchainStatementPDF } =
        await import("./blockchainStatementPdfTemplate");

      blob = await pdf(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        BlockchainStatementPDF({ data, logoUrl, products }) as any
      ).toBlob();
    }

    // Create a download link directly
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (error) {
    logError("Error generating PDF", error);
    throw new Error("Failed to generate PDF statement");
  }
}

// Helper function to create a filename for the statement
export function createStatementFilename(
  currency: string,
  startDate: string,
  endDate: string
): string {
  return `${currency}_Statement_${startDate}_to_${endDate}.pdf`;
}
